import { type UseQueryResult, useQuery } from 'react-query';
import {
  SwitchCompanyResponseDto,
  SwitchConfigurationService,
} from '../../services/wealthlane-customer-services';
import { OptionType } from '../../types/common';

const useGetSwitchableCompaniesForSwitchPage = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  OptionType[] | undefined,
  unknown
> => {
  const getCustomerSwitchableCompaniesForSwitchPage = useQuery(
    ['getCustomerSwitchableCompaniesForSwitchPage'],
    async () => {
      return await handleRequest(
        SwitchConfigurationService.getApiCustomerApiUserSwitchableCompaniesForSwitchPage()
      );
    },
    {
      select: (data: SwitchCompanyResponseDto[] | undefined) => {
        return data?.map((company) => ({
          label: company.name,
          value: company.id,
        }));
      },
    }
  );

  return getCustomerSwitchableCompaniesForSwitchPage;
};

export default useGetSwitchableCompaniesForSwitchPage;
